import { Typography } from '@navi/web-ui/lib/primitives';

type ILanPopperProps = {
  isMultipleLANsLinked: boolean;
  isPrimaryNumberOfAnotherLan: boolean;
};

const LanPopper = (props: ILanPopperProps) => {
  const { isMultipleLANsLinked, isPrimaryNumberOfAnotherLan } = props;

  if (isMultipleLANsLinked && isPrimaryNumberOfAnotherLan) {
    return (
      <ul>
        <li>
          <div className="flex flex-row">
            {isMultipleLANsLinked ? (
              <Typography variant="p4" color="var(--grayscale-3)" as="span">
                <Typography variant="h5" color="var(--grayscale-2)" as="span">
                  Multiple LANs{' '}
                </Typography>{' '}
                are linked to this <br />
                number
              </Typography>
            ) : null}
          </div>
        </li>
        <li>
          <div className="flex flex-row">
            {isPrimaryNumberOfAnotherLan ? (
              <div className="flex flex-row">
                <Typography variant="p4" color="var(--grayscale-3)" as="span">
                  This is{' '}
                  <Typography variant="h5" color="var(--grayscale-2)" as="span">
                    primary number{' '}
                  </Typography>{' '}
                  of <br /> another LAN
                </Typography>
              </div>
            ) : null}
          </div>
        </li>
      </ul>
    );
  }
  if (isMultipleLANsLinked) {
    return (
      <div className="flex flex-row ml-4 my-4">
        <Typography variant="p4" color="var(--grayscale-3)" as="span">
          <Typography variant="h5" color="var(--grayscale-2)" as="span">
            Multiple LANs{' '}
          </Typography>{' '}
          are linked to this <br />
          number
        </Typography>
      </div>
    );
  }
  if (isPrimaryNumberOfAnotherLan) {
    return (
      <div className="flex flex-row ml-4 my-4">
        <Typography variant="p4" color="var(--grayscale-3)" as="span">
          This is{' '}
          <Typography variant="h5" color="var(--grayscale-2)" as="span">
            Primary number{' '}
          </Typography>{' '}
          of <br /> another LAN
        </Typography>
      </div>
    );
  }
  return null;
};

export default LanPopper;
